export default __webpack_public_path__ + "static/ux-design-c46364a4747f5e7a013446391d465987.png";